import { atomWithStorage } from "jotai/utils";

/**
 * Per-space active-tab selection. Persisted in localStorage so the editor
 * remembers which tab the user was working in across reloads.
 *
 * Shape: { [spaceId]: tabId | "loose" | null }
 *   - undefined / null  → no preference (single-tree spaces or first-load)
 *   - tabId string      → that tab is active
 *   - "loose"           → "no tab" view (orphan top-level pages)
 */
export const activeTabBySpaceAtom = atomWithStorage<
  Record<string, string | "loose" | null>
>("commitdoc:active-tab-by-space", {});
